
<template>
    <v-container fluid>
        <v-divider></v-divider>
        <v-row justify="start" class="pt-5">
            <v-col cols="12" md="12" sm="12">
            <v-data-table
                sort-by="filerank"
                :headers="header_files"
                :items="data_files"
                :items-per-page="500"
                :footer-props="footer"
                :loading="isReceiving"
                class="elevation-0"
            >
                <template v-slot:item.filetype="{ item }">
                    <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                        <v-icon size="50" color="primary">mdi-file-pdf-box</v-icon>
                    </a>    
                </template>             
                <template v-slot:item.filesize="{ item }">
                    {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                </template>
                <template v-slot:item.createdAt="{ item }">
                    {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon color="primary" @click="previewFile(item)">
                        <v-icon>mdi-text-box-search</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
    components: {

    },
    props: {
        files: {
            type: Array
        },
        data: Object,
        id: String,
        route: String,
    },
    computed: {
        ...mapState('File', ['isReceiving']),
    },
    data () {
        return {
            header_files: [
                { text: "#", value: "filerank", width: "10px" },
                { text: "File", value: "filetype", width: "8%" },
                { text: "Name", value: "filename" },
                { text: "Size", value: "filesize", width: "10%" },
                { text: "Created", value: "createdAt", width: "10%" },
                { text: "Actions", value: "actions", sortable: false, width: "10%"  },
            ],
            data_files: [],
            footer: {'items-per-page-options': [500, 1000, 5000]},
        }
    },
    methods: {
        previewFile(item){
            let params = Object.assign({}, this.data);
            params.fileurl = item.fileurl;
            params._isFrom = this.$route.name;
            this.$router.push({ name: "FilePreview", params: params });
        },
    },
    created(){
        this.data_files = Object.assign([], this.files);
    }
}
</script>